import { TemplateCta, TemplateFooter, TemplateMeta } from './TemplateParts';

export default function SaveTheDateEditorialRose({ data }) {
  const {
    artTypeLabel,
    coupleName,
    rows,
    shortPhrase,
    ctaText,
    showSiteLink,
    siteUrl,
    showQrCode,
    textColor,
    textShadow,
    accentColor,
    titleStyle,
    bodyStyle,
    isPremium
  } = data;

  return (
    <div className="absolute inset-0 p-5 md:p-6 flex flex-col">
      <div className="relative flex-1 rounded-[24px] border border-white/25 bg-gradient-to-b from-white/8 via-black/22 to-black/48 overflow-hidden">
        <div className="absolute top-5 left-5 right-5 flex items-center justify-between">
          <span className="rounded-full px-3 py-1 text-[10px] uppercase tracking-[0.16em] font-semibold bg-white/12 text-white border border-white/18">
            {artTypeLabel}
          </span>
          {isPremium && (
            <span className="rounded-full px-3 py-1 text-[10px] uppercase tracking-[0.14em] font-semibold bg-[#FFF4E5] text-[#9C784C]">
              Premium
            </span>
          )}
        </div>

        <div className="absolute left-4 right-4 bottom-4 rounded-[24px] bg-[#1D141A]/74 border border-white/24 shadow-[0_18px_34px_rgba(0,0,0,0.34)] p-5 md:p-6">
          <h4 className="text-[2.2rem] md:text-[3rem] font-bold leading-[1.02]" style={titleStyle}>
            {coupleName}
          </h4>

          <div className="mt-4">
            <TemplateMeta rows={rows} textColor={textColor} textShadow={textShadow} family={bodyStyle.metaFamily} tracking={bodyStyle.metaTracking} />
          </div>

          {shortPhrase ? (
            <p className="mt-4 text-sm md:text-base" style={bodyStyle.style}>
              {shortPhrase}
            </p>
          ) : null}

          {ctaText ? (
            <div className="mt-4">
              <TemplateCta text={ctaText} textColor={textColor} textShadow={textShadow} mode="line_label" />
            </div>
          ) : null}

          <TemplateFooter
            showSiteLink={showSiteLink}
            siteUrl={siteUrl}
            showQrCode={showQrCode}
            textColor={textColor}
            accentColor={accentColor}
            darkSurface
          />
        </div>
      </div>
    </div>
  );
}
